export const env = ['test', 'development'].includes(process.env.NODE_ENV)
  ? process.env
  : window.env;
